import { render } from "./Page-conception3D.vue?vue&type=template&id=cc5f6a7c&scoped=true"
import script from "./Page-conception3D.vue?vue&type=script&lang=js"
export * from "./Page-conception3D.vue?vue&type=script&lang=js"

import "./Page-conception3D.vue?vue&type=style&index=0&id=cc5f6a7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc5f6a7c"]])

export default __exports__